import { computed } from "vue";
// import { useLeadStore } from '@/store/LeadStore';
// import { useGlobalVuelidate } from '@/store/LeadValidator';
import { QualIssue } from '@/services/QualClasses';
import { parseInt } from "lodash";
import { useFormStores as useStores } from '@/rules/_useFormStores';

// function useStores() {
//   let lead = useLeadStore();
//   let v$ = useGlobalVuelidate();
//   return {
//     lead: lead,
//     v$: v$
//   }
// }

export const rules = {
  AssignedPartner: computed(() => {
    let { lead } = useStores();
    const partner = (lead.address.assigned_partner || '').toString().trim().toLowerCase();
    const wantsToRegisterAnyway = lead.registration.WantsToRegisterAnyway === true;

    if (wantsToRegisterAnyway) {
      return null;
    }

    if (partner == 'energieploeg') {
      return new QualIssue({
        title: 'Uw ondersteuner is Energieploeg',
        description: 'Ga verder via <a href="https://energieploeg.nl/vhf/" target="_blank" rel="noopener noreferrer" style="color:#4b8a55;font-weight:600;text-decoration:underline;">energieploeg.nl/vhf</a>.',
        punishEarly: true,
        view: 'formAddress'
      });
    }

    if (partner == 'rel') {
      return new QualIssue({
        title: 'Uw ondersteuner is REL',
        description: 'Ga verder via <a href="https://regionaalenergieloket.nl/midden-groningen/huisadvies" target="_blank" rel="noopener noreferrer" style="color:#4b8a55;font-weight:600;text-decoration:underline;">regionaalenergieloket.nl/midden-groningen/huisadvies</a>.',
        punishEarly: true,
        view: 'formAddress'
      });
    }

    if (partner == 'jgh bespaaradvies') {
      return new QualIssue({
        title: 'Uw ondersteuner is JGH Bespaaradvies',
        description: 'Ga verder via <a href="https://jghbespaaradvies.nl/afspraak-maken" target="_blank" rel="noopener noreferrer" style="color:#4b8a55;font-weight:600;text-decoration:underline;">https://jghbespaaradvies.nl/afspraak-maken</a>. Of neem contact op via 050 234 05 05.',
        punishEarly: true,
        view: 'formAddress'
      });
    }

    return null;
  }),

  // check if property owner
  PropertyOwner: computed(() => {
    let { lead } = useStores();
    if (lead.ownership.PropertyOwner === false && lead.ownership.OwnerPermission === false) {
      return new QualIssue({
        title: 'U bent niet de eigenaar',
        view: 'formOwnership',
        description:
          'Alleen de eigenaar van het pand kan toestemming geven voor isolatie.',
      });
    }
    return null;
  }),

  // check if hoa permission is provided
  HoaPermission: computed(() => {
    let { lead } = useStores();
    if (lead.ownership.HoaMember == true && !lead.ownership.HoaPermission) {
      return new QualIssue({
        title: 'Toestemming VVE ontbreekt',
        view: 'formOwnership',
        description:
          'Bij een VVE is toestemming van de vereniging noodzakelijk.',
      });
    }
    return null;
  }),

  // construction year after 2012
  ConstructionYear: computed(() => {
    let { lead } = useStores();
    let intConstructionYear = parseInt(lead.property.ConstructionYear);
    if (intConstructionYear > 2012) {
      return new QualIssue({
        view: 'formProperty',
        color: 'error',
        title: 'Uw woning voldoet al aan de standaard voor woningisolatie',
        description:
          'Woningen van n&aacute; 2012 voldoen per het bouwbesluit al aan de standaard voor woningisolatie. U hoeft dus niet meer te isoleren en valt dus buiten de regeling.',
      });
    }
    return null;
  }),

  // gas consumption (combined with construction year)
  // GasConsumption: computed(() => {
  //   let { lead } = useStores();
  //   let intConstructionYear = parseInt(lead.property.ConstructionYear);
  //   let intGasConsumption = parseInt(lead.property.GasConsumption);
  //   if (
  //     intConstructionYear > 1978 &&
  //     intGasConsumption < 800
  //   ) {
  //     return new QualIssue({
  //       type: 'warning',
  //       title: 'Laag rendement',
  //       description:
  //         'Bij nieuwere huizen (na 1978) met een dergelijk laag gasverbruik heeft isolatie vaak een laag rendement.',
  //     });
  //   }
  //   return null;
  // }),

  // check if house type is suitable
  HouseType: computed(() => {
    let { lead } = useStores();
    if (lead.property.HouseType == 'Garage') {
      return new QualIssue({
        title: 'Wij isoleren geen garages',
        view: 'formProperty',
      });
    } else if (lead.property.HouseType == 'Anders') {
      return new QualIssue({
        title: "Uw woningtype is 'anders'",
        view: 'formProperty',
        description:
          "U heeft 'anders' aangegeven als type woning. Indien uw type niet voorkomt in de lijst vragen we u graag contact op te nemen om de mogelijkheden te bespreken met een adviseur.",
      });
    }
    return null;
  }),

  IsMonument: computed(() => {
    let { lead } = useStores();
    if (lead.property.IsMonument === true) {
      return new QualIssue({
        // type: 'error',
        // color: 'warning',
        view: 'formProperty',
        title: 'Uw woning is een (rijks)monument',
        description:
          'Uw woning valt buiten de ondersteuning van het Bureau voor Verduurzamen en voor monumenten geldt een aparte route, ga voor meer informatie over de isolatieaanpak voor monumenten naar <a href="https://isolatie.nijbegun.nl/stappenplan/eigenaren-van-een-monument/" target="_blank" rel="noopener noreferrer" style="color:#4b8a55;font-weight:600;text-decoration:underline;">informatie over de isolatieaanpak voor monumenten</a>.',
      });
    }
    return null;
  }),

  InVersterkingsprogramma: computed(() => {
    let { lead } = useStores();
    if (lead.property.InVersterkingsprogramma === true && lead.property.VersterkingsprogrammaUitgevoerd === false) {
      return new QualIssue({
        view: 'formProperty',
        title: 'Uw woning zit in het versterkingsprogramma',
        description:
          'Uw woning zit in het versterkingsprogramma van de NCG. U hoeft voor isolatie geen apart traject bij ons te doorlopen. Neem contact op met de NCG voor verdere stappen rondom versterking en isolatie.',
      });
    }
    return null;
  }),

  FloorInsulated: computed(() => {
    let { form } = useStores('currentInsulation');
    if (form.FloorInsulated == 'Ja') {
      return new QualIssue({
        view: 'formCurrentInsulation',
        title: 'Uw vloer is al geïsoleerd',
        type: 'error',
        color: 'success',
        description:
          'Goed nieuws! Uw vloer is al geïsoleerd. U hoeft de vloer dus niet meer te isoleren en doet niet mee met de actie.',
      });
    } else if (form.FloorInsulated == 'Niet mogelijk') {
      return new QualIssue({
        view: 'formCurrentInsulation',
        title: 'Vloer isoleren is niet mogelijk',
        type: 'error',
        description:
          'U heeft aangegeven dat het isoleren van de vloer niet mogelijk is. U doet daarom niet mee met de actie.',
      });
    }
    return null;
  }),

  Participate: computed(() => {
    let { lead } = useStores();
    if (lead.currentInsulation.Participate === false) {
      return new QualIssue({
        title: 'Afmelding wijkaanpak',
        view: 'formCurrentInsulation',
        description: 'Door op "Volgende" te klikken wordt u afgemeld voor de wijkaanpak.',
        summaryDescription: 'U heeft aangegeven niet mee te willen doen met de wijkaanpak. U wordt afgemeld voor de regeling.',
      });
    }
    return null;
  }),

  Maatregel29Support: computed(() => {
    let { lead } = useStores();
    if (lead.advice.Maatregel29Support !== false) {
      return null;
    }

    const isBosman = (lead.meta.LeadSource || '').toLowerCase().includes('bosman');

    if (isBosman) {
      return new QualIssue({
        type: 'warning',
        view: 'formIsolatieaanpakSupport',
        title: 'U wordt niet aangemeld voor ondersteuning',
        description:
          'U wordt niet aangemeld voor ondersteuning. Heeft u in de toekomst vragen of loopt u vast? Dan kunt u zich via het <a href="https://isolatie.nijbegun.nl" target="_blank" rel="noopener noreferrer">portaal van Nij Begun</a> alsnog ondersteuning aanvragen.',
      });
    }

    return new QualIssue({
      type: 'error',
      view: 'formIsolatieaanpakSupport',
      title: 'U wilt geen ondersteuning',
      description:
        'Deze pagina is bedoeld om u aan te melden voor ondersteuning bij de isolatieaanpak van Nij Begun door Bureau voor Verduurzamen. U geeft aan geen ondersteuning te willen. In dat geval mogen wij u niet helpen.',
      summaryDescription:
        'U heeft aangegeven geen ondersteuning van Bureau voor Verduurzamen te willen. Daarom mogen wij u niet helpen.',
    });
  }),

};
